module.exports = __webpack_public_path__ + "static/media/30.16e21b0b.jpg";